const workloadList = () => import('@/views/main/workload/list/List.vue')
export default {
  path: '/main/workload/list',
  name: 'workloadList',
  component: workloadList,
  children: []
}
